import { useEffect, useState } from "react";

import Chart from 'react-apexcharts'
import moment from "moment";

import LabelForms from '../../../components/labelForms'

import style from '../reports.module.css'

export default function ChartProductByAreas({products}) {
    const [series, setSeries] = useState([]);
    const [options, setOptions] = useState({});

    useEffect(() => {
        const group = products.reduce((acc, item) => {
            if (!acc[item.AreasUse.name]) {
              acc[item.AreasUse.name] = [];
            }
            acc[item.AreasUse.name].push(item.length);
            return acc;
        }, {})
          
        let product =[]
        let name =[]
        for (let [area, products] of Object.entries(group)) {
            product.push(products.length)
            name.push(area)
        }
        setOptions({
            labels: name,
                plotOptions: {
                  pie: {
                    donut: {
                      size: '50%',
                    },
                  },
                },
                legend: {
                  position: 'bottom',
                  offsetY: 0,
                
             },
        })
        setSeries(product)
        
    }, [products]);

    return (
        <>
            <div className={style.chart}>
                <LabelForms>Produtos por áreas de ultilização</LabelForms>
                <Chart options={options} series={series} type="donut" />
            </div>
        </>
    )
}